<template>
  <div>
    <el-drawer title="交易设置" :visible.sync="dialogVisible" direction="rtl">
    <div class="setBox">
      <div class="setTitle">下单</div>
      <div class="setItem">
        <div class="setLable">下单时弹出提示确认对话框</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_show_Dialog" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
      <div class="setItem">
        <div class="setLable">下单成功使用对话框提示</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_success_Dialog" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
      <div class="setItem">
        <div class="setLable">下单失败自动清除下单信息</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_fail_clear" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
      <div class="setItem">
        <div class="setLable">下单成功自动清除下单信息</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_success_clear" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
      <div class="setItem">
        <div class="setLable">下单失败使用对话框提示</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_fail_Dialog" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
      <div class="setItem">
        <div class="setLable">下单成功播放提示音</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_Ordersuccess_Playsound" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
    </div>
    <div class="setBox">
      <div class="setTitle">撤单</div>
      <div class="setItem">
        <div class="setLable">撤单成功使用对话框提示</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_revoke_success_Dialog" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
      <div class="setItem">
        <div class="setLable">撤单时弹出提示确认对话框</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_revoke_Dialog" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
      <div class="setItem">
        <div class="setLable">撤单失败使用对话框提示</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_revoke_fail_Dialog" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
    </div>
    <div class="setBox">
      <div class="setTitle">填充</div>
      <div class="setItem">
        <div class="setLable">自动填充价格 对手价</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_AutoFill_price" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
      <div class="setItem">
        <div class="setLable">自动填充数量</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_AutoFill_quantity" active-color="#ffffff" inactive-color="#404040" @change="change()"></el-switch>
      </div>
    </div>
    <div class="setBox">
      <div class="setTitle">布局</div>
      <div class="setItem">
        <div class="setLable">交易组件靠右</div>
        <el-switch :width="54" v-model="FAST_SET.FAST_TradeView_Right" active-color="#ffffff" inactive-color="#404040" @change="change(1)"></el-switch>
      </div>
    </div>
          <!-- <el-checkbox-group v-model="list">
            <el-checkbox label="FAST_show_Dialog" style="width: 260px" name="type">下单时弹出提示确认对话框</el-checkbox>
            <el-checkbox label="FAST_success_clear" style="width: 260px" name="type">下单成功自动清除下单信息</el-checkbox>
            <el-checkbox label="FAST_success_Dialog" style="width: 260px" name="type">下单成功使用对话框提示</el-checkbox>
            <el-checkbox label="FAST_fail_Dialog" style="width: 260px" name="type">下单失败使用对话框提示</el-checkbox>
            <el-checkbox label="FAST_fail_clear" style="width: 260px" name="type">下单失败自动清除下单信息</el-checkbox>
            <el-checkbox label="FAST_revoke_Dialog" style="width: 260px" name="type">撤单时弹出提示确认对话框</el-checkbox>
            <el-checkbox label="FAST_revoke_success_Dialog" style="width: 260px" name="type">撤单成功使用对话框提示</el-checkbox>
            <el-checkbox label="FAST_revoke_fail_Dialog" style="width: 260px" name="type">撤单失败使用对话框提示</el-checkbox>
            <el-checkbox label="FAST_AutoFill_price" style="width: 260px" name="type">自动填充价格 对手价</el-checkbox>
            <el-checkbox label="FAST_AutoFill_quantity" style="width: 260px" name="type">自动填充数量</el-checkbox>
            <el-checkbox label="FAST_TradeView_Right" style="width: 260px" name="type">交易组件靠右</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      dialogVisible: false,
      FAST_SET: {}
    }
  },
  methods: {
    change(value) {
      localStorage.setItem('FAST_SET', JSON.stringify(window.g.FAST_SET))
      if (value) {
        window.dispatchEvent(new Event('TradViewChange'))
      }
    },
    showDialog() {
      this.dialogVisible = true
      this.FAST_SET = window.g.FAST_SET
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-drawer {
  height: initial !important;
  width: 556px !important;
  background: #1A1A1A;
  border: 1px solid #666666;
  padding-left: 20px;
  .el-drawer__header {
    padding: 60px 10px 12px;
    margin: 0;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
  }
  .setBox {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 25px 10px 16px;
    .setTitle {
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      margin-bottom: 17px;
    }
    .setItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      .setLable {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFEFE;
      }
      &:last-child {
        margin: 0;
      }
      .is-checked {
        .el-switch__core {
          &::after {
            margin-left: -23px;
          }
        }
      }
      .el-switch__core {
        height: 26px;
        border-radius: 26px;
        &::after {
          width: 22px;
          height: 22px;
          background: #1A1A1A;
        }
      }
    }
  }
}
</style>
